<template>
  <div class="mw-split-container mw-bar-data org_mgr">
    <split-pane :defaultSize="358" split="vertical">
      <template slot="paneL">
        <div class="mw-split-left">

          <mw-dialog  size="large_large" @opened="initUserImg" :before-close="closeUserDialog" :title=" $lang(user.id ? '编辑用户' : '新建用户') " ref="userAddDialog" :close-on-click-modal="false">
            <div class="mw-toolbar">
              <el-button @click="closeUserDialog" type="primary">
                <i class="fa fa-mail-reply "></i> {{$lang("关闭")}}</el-button>
              <el-button @click="newUser" type="primary" style="margin:4px 7px;"  v-show="showSaveBtn || (showBtn && !readMode) || (readMode && !noResetPwd)">
                <i class="fa fa-file-text-o"></i> {{$lang("保存")}}</el-button>
              <el-button @click="findRoles" type="primary"><i class="fa fa-vcard"></i>  {{$lang("查看角色")}}</el-button>
              <span v-if="user.id" class="pull-right">
                <b>{{$lang("编码")}}：</b>{{user.id}}
              </span>
            </div>

            <div class="mw-toolbar__body">
              <template>
              <el-row>
                <!-- <el-tabs v-model="activeName" type="card"> -->
                  <!-- <el-tab-pane label="基本信息" name="basic"> -->
                    <el-form :model="user" :rules="rules" ref="userForm" label-width="130px">

                        <el-col :span="12">
                          <el-form-item :label="$lang('登录账号')" prop="loginId">
                            <el-input v-model="user.loginId" :disabled="readMode||hideBtn"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item :label="$lang('真实姓名')" prop="name">
                            <el-input v-model="user.name" v-on:input="getPYIndexStr" :disabled="readMode"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('姓名首字母')" prop="pinyin">
                            <el-input v-model="user.pinyin" :disabled="readMode"></el-input>
                            <el-button @click="getPYIndexStr" v-if="!readMode">{{$lang('获取')}}</el-button>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('英文名')">
                            <el-input v-model="user.Englishname" :disabled="readMode"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('用户密码')" prop="password">
                            <el-input v-model="user.password" :disabled="noResetPwd ? !(!user.id) : false"></el-input>
                            <el-button @click="user.password = ''" v-if="!noResetPwd">{{$lang('重置')}}</el-button>
                          </el-form-item>
                        </el-col>

                        <!-- <el-col :span="12">
                          <el-form-item label="编码" prop="id">
                            <el-input v-model="user.id" :readonly="editUser ? true:false"></el-input>
                          </el-form-item>
                        </el-col> -->
                      <!--北信源人员密级-->
                      <el-col :span="12">
                        <el-form-item :label="$lang('人员密级')">
                          <el-select v-model="user.userLevel" :placeholder="$lang('请选择')" style="width:70%;" >
                            <el-option
                              v-for="item in userLevelOption"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>


                      <el-col :span="12">
                          <el-form-item :label="$lang('员工号')">
                            <el-input v-model="user.staffId" :disabled="readMode"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('座机电话')">
                            <el-input v-model="user.phone" :disabled="readMode"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item :label="$lang('移动电话')">
                            <el-input v-model="user.mobile" :disabled="readMode"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('电子邮箱')">
                            <el-input v-model="user.email" :disabled="readMode"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('企业邮箱')">
                            <el-input v-model="user.companyEmail" :disabled="readMode"></el-input>
                          </el-form-item>
                        </el-col>


                        <el-col :span="12">
                          <el-form-item :label="$lang('信息公开')">
                            <el-radio-group v-model="user.isSecret" :disabled="readMode">
                              <el-radio label="1">{{$lang('是')}}</el-radio>
                              <el-radio label="2">{{$lang("否")}}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('性别')">
                            <el-radio-group v-model="user.sex" :disabled="readMode">
                              <el-radio label="1">{{$lang('男')}}</el-radio>
                              <el-radio label="2">{{$lang('女')}}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('入职日期')">
                            <el-date-picker
                              v-model="user.timeOfJoinInWork"
                              type="date"
                              :disabled="readMode"
                              >
                            </el-date-picker>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('工龄')">
                            <el-input v-model="user.workyear_" style="width:70%;" controls-position="right" :min="0" :disabled="true"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('出生日期')">
                            <el-date-picker
                              v-model="user.birth"
                              :disabled="readMode"
                              type="date">
                            </el-date-picker>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('职级')">
                            <el-input v-model="user.jobs" :disabled="readMode"></el-input>
                          </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12">
                          <el-form-item label="年龄">
                            <el-input-number v-model="user.age_" controls-position="right" :min="0" style="width:70%;"></el-input-number>
                          </el-form-item>
                        </el-col> -->

                        <el-col :span="12">
                          <el-form-item :label="$lang('是否列选')">
                            <el-radio-group v-model="user.listAble" :disabled="readMode">
                              <el-radio label="1">{{$lang('是')}}</el-radio>
                              <el-radio label="2">{{$lang('否')}}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('学历')">
                            <el-select v-model="user.edu" :placeholder="$lang('请选择')" style="width:70%;" :disabled="readMode">
                              <el-option
                                v-for="item in education"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('证件号码')">
                            <el-input v-model="user.idNumber" :disabled="readMode"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('房间号')">
                            <el-input style="" v-model="user.roomNum" :disabled="readMode"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item :label="$lang('绑定秘书')">
                            <el-input v-model="user.secretary" style="width:60%;" :disabled="readMode"></el-input>
                            <el-button @click="bindSec" v-if="!readMode">{{$lang('选择')}}</el-button>
                            <el-button @click="clearSec" v-if="!readMode">{{$lang('清除')}}</el-button>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item :label="$lang('绑定秘书')" v-show="false">
                            <el-input v-model="user.secretaryId" :disabled="readMode" style="width:60%;"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('岗位')">
                            <el-input v-model="user.position" :disabled="readMode"></el-input>
                            <el-button @click="chooseSure('choosePost')" v-if="!readMode">{{$lang('选择')}}</el-button>
                          </el-form-item>
                        </el-col>
                      <el-col :span="12">
                        <el-form-item :label="$lang('人员类型')">
                          <el-radio-group v-model="user.persontype" :disabled="readMode">
                            <el-radio label="1">{{$lang('本地员工')}}</el-radio>
                            <el-radio label="2">{{$lang('外派员工')}}</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item :label="$lang('微信号')" v-if="!showMJBS">
                          <el-input v-model="user.weiChatNum" :disabled="readMode"></el-input>
                        </el-form-item>
                        <el-form-item :label="$lang('密级')" v-else>
                          <el-select v-model="user.mjbs" :placeholder="$lang('请选择')" style="width:70%;" :disabled="readMode||hideBtn">
                            <el-option key="无" label="无" value="无"></el-option>
                            <el-option key="非涉密" label="非涉密" value="非涉密"></el-option>
                            <el-option key="一般" label="一般" value="一般"></el-option>
                            <el-option key="重要" label="重要" value="重要"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                        <el-col :span="12">
                          <el-form-item :label="$lang('电子签名')">
                            <div class="box" v-show="signUrl">
                                  <img :src="signUrl" class="avatar" style="width:95px;height:43px;">
                                  <div class="box-content" style="top:-12%;">
                                    <ul class="icon">
                                      <li ref="signPlusUploader">
                                        <a href="#" style="width: 15px;height: 15px;line-height: 15px;font-size:12px;">
                                        <i class="el-icon-plus" ></i></a>

                                      </li>

                                          <li title="下载" @click="downloadAttachment(fileSignList[0],signParams)"><a href="#" style="background:#67C23A;width: 15px;
            height: 15px;
            line-height: 15px;font-size:12px;"><i class="el-icon-download"></i></a></li>
                                          <li @click="remove(fileSignList[0])"><a href="#" style="width: 15px;
            height: 15px;
            line-height: 15px;font-size:12px;"><i class="el-icon-close"></i></a></li>
                                    </ul>
                                  </div>
                                </div>
                                <el-button size="small" type="primary" ref="signUploader" v-show="!signUrl && !readMode">{{$lang('选择')}}</el-button>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('头像')">
                          <div class="box" v-show="imageUrl">
                            <img :src="imageUrl" class="avatar" :style="avatarStyle">
                            <div class="box-content">
                              <ul class="icon">
                                <li ref="imgPlusUploader"><a href="#"><i class="el-icon-plus"></i></a></li>
                                <li title="下载" @click="downloadAttachment(fileList[0],defaultParams)"><a href="#" style="background:#67C23A"><i class="el-icon-download"></i></a></li>
                                <li @click="removePic(fileList[0],'avatar')"><a href="#"><i class="el-icon-close"></i></a></li>
                              </ul>
                            </div>
                          </div>
                          <el-button size="small" type="primary" ref="imgUploader" v-show="!imageUrl && !readMode">{{$lang('添加')}}</el-button>
                          </el-form-item>
                        </el-col>
                        <hr style="border: 1px solid #eee;">
                        <el-col :span="12">
                          <el-form-item :label="$lang('主属部门')" prop="primaryDepartmentName" >
                            <el-input v-model="user.primaryDepartmentName" readonly></el-input>
                            <el-button v-show="user.id && !readMode"  @click="showPtree()">{{$lang('选择')}}</el-button>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12" v-show="false">
                          <el-form-item :label="$lang('主属部门')" prop="primaryDepartmentId" >
                            <el-input v-model="user.primaryDepartmentId" readonly></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('序号')">
                            <el-input-number v-model="user.sn" :min="1" :disabled="readMode" controls-position="right" style="width:70%;"></el-input-number>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('所属部门')" prop="departmentName">
                            <el-input v-model="user.departmentName" readonly></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12" v-show ="false">
                          <el-form-item :label="$lang('所属部门')" prop="departmentId">
                            <el-input v-model="user.departmentId" :disabled="readMode"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item :label="$lang('绑定IP')" prop="primaryDepartmentName" >
                            <el-input v-show="user.bindIP" v-model="user.bindIP" readonly></el-input>
                            <el-button v-show="user.bindIP"  @click="removeIp(2)" v-if="!readMode">{{$lang('解除绑定')}}</el-button>
                            <span v-show="!user.bindIP" v-if="!readMode">{{$lang("未绑定")}}</span>
                          </el-form-item>
                        </el-col>
                    </el-form>
                  <!-- </el-tab-pane> -->
                  <!-- <el-tab-pane label="其他信息" v-show="false" name="others"> -->
                    <!-- <el-row> -->
                      <el-form v-show="false"  label-width="130px">


                        <el-col :span="12">
                          <el-form-item label="员工级别">
                            <el-input v-model="user.staffLevel" style="width: 60%" readonly></el-input>
                            <el-button @click="chooseSure('staffLevel')">选择</el-button>
                            <el-button @click="clearStaLevel">清空</el-button>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item label="二类信息查看级别">
                            <el-input v-model="user.secondRank" style="width: 60%" readonly></el-input>
                            <el-button @click="chooseSure('secondRank')">选择</el-button>
                            <el-button @click="clearseaLevel">清空</el-button>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item label="三类信息查看级别">
                            <el-input v-model="user.thirdRank" style="width: 60%" readonly></el-input>
                            <el-button @click="chooseSure('cthirdLevel')">选择</el-button>
                            <el-button @click="clearLevel">清空</el-button>
                          </el-form-item>
                        </el-col>

                        <el-col :span="24">
                          <el-form-item label="主管部门">
                            <el-input v-model="user.zgdept" style="width: 80%" readonly></el-input>
                            <el-button @click="chooseSure('zgDeptDialog')">选择</el-button>
                            <el-button @click="clearZgdept">清空</el-button>
                          </el-form-item>
                        </el-col>

                        <el-col :span="24">
                          <el-form-item label="一级单位">
                            <el-input v-model="user.firstLevelDept" style="width: 80%" readonly></el-input>
                            <el-button @click="chooseSure('firstDept')">选择</el-button>
                            <el-button @click="clearfirstDept">清空</el-button>
                          </el-form-item>
                        </el-col>

                        <el-col :span="24">
                          <el-form-item label="二级单位">
                            <el-input v-model="user.secondLevelDept" style="width: 80%" readonly></el-input>
                            <el-button @click="chooseSure('secondDept')">选择</el-button>
                            <el-button @click="clearsecondDept">清空</el-button>
                          </el-form-item>
                        </el-col>

                        <el-col :span="24">
                          <el-form-item label="三级单位">
                            <el-input v-model="user.thirdLevelDept" style="width: 80%" readonly></el-input>
                            <el-button @click="chooseSure('thirdDept')">选择</el-button>
                            <el-button @click="clearthirdDept">清空</el-button>
                          </el-form-item>
                        </el-col>

                      </el-form>

                  <!-- </el-tab-pane> -->
                <!-- </el-tabs> -->

              </el-row>

              </template>
            </div>
          </mw-dialog>

          <mw-dialog   size="large_small" :before-close="closeDeptDialog" :title=" $lang( dept.id ? '编辑部门' : '新建部门' )" ref="deptDialog" :close-on-click-modal="false">
            <div class="mw-toolbar">
              <el-button @click="closeDeptDialog" type="primary"><i class="fa fa-mail-reply "></i> {{$lang('关闭')}}</el-button>
              <el-button @click="saveDept" style="margin:4px 7px" type="primary">
                <i class="fa fa-file-text-o"></i> {{$lang('保存')}}</el-button>
              <span v-if="dept.id" class="pull-right">
                <b>{{$lang('ID')}}：</b>{{dept.id}}
              </span>
            </div>
            <div class="mw-toolbar__body">
              <el-row>

                <el-form label-width="150px" :model="dept"  ref="ruleForm" :rules="deptRule">
                    <el-col :span="12">
                      <el-form-item :label="$lang('部门名称')" prop="name">
                        <el-input v-model="dept.name"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$lang('部门简称')">
                        <el-input v-model="dept.shortname"></el-input>
                      </el-form-item>
                    </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$lang('英文名称')">
                      <el-input v-model="dept.Englishname"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" >
                    <el-form-item :label="$lang('编码')">
                      <el-input v-model="dept.code"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$lang('部门类型')">
                      <el-radio-group v-model="dept.flag">
                        <el-radio label="1">{{$lang('单位')}}</el-radio>
                        <el-radio label="2">{{$lang('部门')}}</el-radio>
                        <el-radio label="3">{{$lang('子部门')}}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$lang('是否列选')">
                      <el-radio-group v-model="dept.listAble">
                        <el-radio label="1">{{$lang('是')}}</el-radio>
                        <el-radio label="2">{{$lang('否')}}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item :label="$lang('管理员','管  理  员 ')" >
                      <el-input
                        type="textarea"
                        v-model="dept.adminName"  style="width: 75%" readonly>
                      </el-input>
                      <el-button @click="showChooseAdminDialog">{{$lang('选择')}}</el-button>
                      <el-button @click="clearMan"> {{$lang('清空')}}</el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-show="false">
                    <el-form-item :label="$lang('序号')">
                      <el-input-number v-model="dept.sn" :min="1" controls-position="right" ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-show="false">
                    <el-form-item :label="$lang('上级')">
                      <el-input v-model="dept.parentName" readonly></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12" v-show="false">
                    <el-form-item label="上级">
                      <el-input v-model="dept.parentId"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" v-show="false">
                    <el-form-item label="管理员" >
                      <el-input
                        type="textarea"
                        v-model="dept.adminId"  style="width: 75%" readonly>
                      </el-input>
                    </el-form-item>
                  </el-col>



                </el-form>

              </el-row>

            </div>
          </mw-dialog>

          <div class="mw-toolbar">
            <el-button @click="addDepart" v-show="showBtn && !readMode && !hideBtn"><i class="fa fa-plus-square"></i>{{$lang('添加')}}</el-button>
            <el-button @click="editDept"  v-show="showBtn && !readMode"><i class="fa fa-pencil fa-fw "></i>{{$lang('编辑')}}</el-button>
            <el-button @click="deleteDepartment"  v-show="showBtn && !readMode && !hideBtn"><i class="fa fa-trash-o "></i>{{$lang('删除')}}</el-button>
            <el-button @click="expand" v-show="expandFlag==1"><i class="fa fa-angle-double-down"></i> {{$lang('展开')}}
            </el-button>
            <el-button @click="closed" v-show="expandFlag!=1"><i class="fa fa-angle-double-up"></i>{{$lang('折叠')}}
            </el-button>
            <!--   <el-button   class="btn" @click="leadshow = true" style="font-size: 12px">导入部门
               </el-button>-->
            <el-dropdown trigger="hover" @command="handleDeptMoreCommand"  v-show="showBtn && !readMode && !hideBtn">
              <el-button class="el-dropdown-link">
                {{$lang('更多')}}<i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                <el-dropdown-item command="importDept" >{{$lang('导入')}}</el-dropdown-item>
                <el-dropdown-item command="exportDept">{{$lang('导出')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="mw-toolbar__body" ref="deptTreePanelDiv">
            <!-- :defaultParentId="defaultParams1.rootId" -->
            <div class=" treeClass" v-if="defaultParams1 && defaultParams1.rootId"  >
              <mw-tree :url="deptTreeUrl" :async="true" :multiple="false"  :defaultParams="defaultParams1" aliasId="departmentId" @changeItem="aa" @dataFilter="treeDataFilter" :contextMenuItem="menuItem1"
                :autoLoad="false" :dragEnable="userInfo.unitAdmin ? false:true"   :expandedFirst="true" :selectFirst="true"  @move="moveTreeNode"   @changed="loadTableTree" ref="deptTreeData" :types="types"></mw-tree>
             </div>

            <div class="treeClass" v-else >
              <mw-tree :url="deptTreeUrl" :async="true" :multiple="false" :contextMenuItem="menuItem" :autoLoad="false"  @dataFilter="treeDataFilter"
                       :expandedFirst="true" :selectFirst="true"  @changed="loadTableTree" ref="deptTreeData" @move="moveTreeNode" :types="types"></mw-tree>
            </div>


          </div>
        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right">

          <toolbar-table :layout="layout" :autoLoad="false" ref="dataTable" :defaultParams="defaultParams" @rowStyle="tableRowStyle">

          <span slot="dropDown" v-show="showBtn && !readMode">
            <el-dropdown trigger="hover" @command="handleDeptCommand" v-show="showBtn && !readMode && !hideBtn">
              <el-button class="el-dropdown-link">
                <i class="fa fa-cog"></i>{{$lang('部门操作')}}<i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                <el-dropdown-item command="add"><i class="fa fa-plus-square"></i>{{$lang('追加部门')}}
                </el-dropdown-item>
                <el-dropdown-item command="transform"><i class="fa fa-plus-square"></i>{{$lang('转换部门')}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
<!--
            <el-dropdown trigger="hover" @command="handleRoleCommand" v-show="userInfo.ownerAdmin||userInfo.unitAdmin ||!isLimit">
              <el-button class="el-dropdown-link">
                角色操作<i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                <el-dropdown-item command="a">查看角色</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
-->
            <el-dropdown trigger="hover" @command="handleSortCommand" v-show="showBtn && !readMode && !hideBtn">
              <el-button class="el-dropdown-link">
                {{$lang('排序')}}<i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                <el-dropdown-item command="sort" >{{$lang('排序')}}</el-dropdown-item>
                <el-dropdown-item command="top">{{$lang('置顶')}}</el-dropdown-item>
                <el-dropdown-item command="footer">{{$lang('置底')}}</el-dropdown-item>
                <el-dropdown-item command="up">{{$lang('上移')}}</el-dropdown-item>
                <el-dropdown-item command="down"> {{$lang('下移')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown trigger="hover" @command="handleMoreCommand"  v-show="showBtn && !readMode">
              <el-button class="el-dropdown-link">
                {{$lang('更多')}}<i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                <el-dropdown-item command="leadIn"  v-if="!hideBtn">{{$lang('导入')}}</el-dropdown-item>
                <el-dropdown-item command="leadOut" v-if="!hideBtn">{{$lang('导出')}}</el-dropdown-item>
                <el-dropdown-item command="bindip" v-if="hideBtn">{{$lang('ip绑定')}}</el-dropdown-item>
                <el-dropdown-item command="removeip">{{$lang('解除ip绑定')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown trigger="hover" @command="handOverCommand"  v-show="(showBtn && !readMode && showHandOver)||showJBBtn">
              <el-button class="el-dropdown-link">
                {{$lang('交办')}}<i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                <el-dropdown-item command="todo">{{$lang('待办交办')}}</el-dropdown-item>
                <el-dropdown-item command="finish">{{$lang('经办交办')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button style="float:right;margin:9px 3px 0px 0px;" @click="toInvalidUser" size="mini"  v-loading.fullscreen.lock="loading"><i class="fa fa-user-times"></i>{{$lang('无效用户')}}</el-button>
          </span>
          </toolbar-table>
        </div>
      </template>
    </split-pane>

    <mw-dialog ref="secDialog" :title="$lang('帐号绑定IP')">
      <el-form label-width="100px" style="margin-top:20px">
        <el-form-item label="帐号绑定IP">
          <span style="display:inline-block;margin-left:5%;" class="form-content">
              <el-input style="height: 30px;" v-model="bindForm.bindIP"></el-input>
              <el-button class="btn-danger" @click="clearIp" style="margin-left: 20px;">清除</el-button>
          </span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeBindIP">取 消</el-button>
        <el-button type="primary" @click="saveBindIP">确 定</el-button>
      </div>
    </mw-dialog>

    <mw-dialog size="small_small"  :title="$lang('角色浏览')" ref="userRoleDialog" :close-on-click-modal="false" :before-close="closeRoleDialog">
      <queryrole :deptId="checkedId" :userIdentityId="identityId" :userInf="userInfo1" :listAble="listAble" :noResetPwd="noResetPwd"></queryrole>
    </mw-dialog>

    <mw-dialog ref="impDeptDialog" :title="$lang('导入部门数据')" @opened="showDeptUpload" size="mini_small" :footerButton="deptImpBtn">
      <div class="mw-dialog_body" style="margin-top:20px;">
        <el-form label-width="100px">
          <el-col :span="24">
            <el-form-item label="导入说明:">
              <template>
                第一步：单击此处<el-button @click="downloadDeptExcel" >下载模版</el-button><br/>
                第二步：按照模板格式录入部门数据;<br/>
                第三步：上传模板文件:
              </template>
            </el-form-item>
            <el-form-item label="上传文件:">
              <el-button ref="DeptUploader">上传文件</el-button>
              <div class="el-upload__tip">只能上传.xls文件</div>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </mw-dialog>
    <mw-dialog ref="leadDialog" title="导入人员数据" @opened="showUserUpload" size="mini_small" :footerButton="leadButton">
       <div class="mw-dialog_body" style="margin-top:20px;">
          <el-form label-width="100px">
            <el-col :span="24">
              <el-form-item label="导入说明:">
                <template>
                    第一步：单击此处<el-button @click="downloadPersonExcel" >下载模版</el-button><br/>
                    第二步：按照模板格式录入人员数据;<br/>
                    第三步：上传模板文件:
                </template>
              </el-form-item>
              <el-form-item label="上传文件:">
                <el-button ref="UserUploader">上传文件</el-button>
               <div class="el-upload__tip">只能上传.xls文件</div>
              </el-form-item>
            </el-col>
          </el-form>
       </div>
    </mw-dialog>

    <mw-dialog ref="handOverTodo" :title="$lang('待办交办')" size="mini_small" :footerButton="handOverTodoButton">
      <div class="mw-dialog_body" style="margin-top:20px;">
        <el-form label-width="100px">
          <el-col :span="24">
            <el-form-item :label="$lang('原办理人')" prop="assigned">
              <el-input v-model="handOverTodoForm.assigned" readonly></el-input>
              <el-button @click="userChoose({id:'assignedId',name:'assigned',type:1})" >{{$lang('选择')}}</el-button>
            </el-form-item>
            <el-form-item prop="assignedId" v-show="false">
              <el-input v-model="handOverTodoForm.assignedId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$lang('交接收人')" prop="recipient">
              <el-input v-model="handOverTodoForm.recipient" readonly></el-input>
              <el-button @click="userChoose({id:'recipientId',name:'recipient',type:1})">{{$lang('选择')}}</el-button>
            </el-form-item>
            <el-form-item prop="recipientId" v-show="false">
              <el-input v-model="handOverTodoForm.recipientId"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </mw-dialog>

    <mw-dialog size="large_large" :width="'680px'"  :title="$lang('选择用户')" ref="userSelDialog" :footerButton="userSelFooterButton" :close-on-click-modal="false">
      <loadMan ref="handOverUserChoose" :isRadio="true" :defaultParentId="defaultParentId" :listAble="false" ></loadMan>
    </mw-dialog>

    <mw-dialog ref="handOverFinish" :width="'580px'"  :title="$lang('经办交办')" :footerButton="handOverFinishButton">
      <div class="mw-dialog_body" style="margin-top:20px;">
        <el-form label-width="100px">
          <el-col :span="24">
            <el-form-item :label="$lang('原办理人')" prop="assigned">
              <el-input v-model="handOverFinishForm.assigned" readonly></el-input>
              <el-button @click="userChoose({id:'assignedId',name:'assigned',type:2})" >{{$lang('选择')}}</el-button>
            </el-form-item>
            <el-form-item prop="assignedId" v-show="false">
              <el-input v-model="handOverFinishForm.assignedId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$lang('交接收人')" prop="recipient">
              <el-input v-model="handOverFinishForm.recipient" readonly></el-input>
              <el-button @click="userChoose({id:'recipientId',name:'recipient',type:2})">{{$lang('选择')}}</el-button>
            </el-form-item>
            <el-form-item prop="recipientId" v-show="false">
              <el-input v-model="handOverFinishForm.recipientId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$lang('应用范围')" prop="moduleName">
              <el-input type="textarea" :autosize="{minRows: 2}"
                        placeholder="" v-model="handOverFinishForm.moduleName" readonly style="width:300px;">
              </el-input>
              <el-button @click="moduleChoose">{{$lang('选择')}}</el-button>
              <el-button @click="moduleClear">{{$lang('清空')}}</el-button>
            </el-form-item>
            <el-form-item prop="recipientId" v-show="false">
              <el-input v-model="handOverFinishForm.moduleId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$lang('时间范围')" prop="startTime">
              <el-date-picker style="width:150px;"
                v-model="handOverFinishForm.startTime"
                type="date">
              </el-date-picker>{{$lang('至：')}}
              <el-date-picker style="width:150px;"
                v-model="handOverFinishForm.endTime"
                type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$lang('备注')">
              {{$lang('1、此交办表只是赋予交接人在汇总视图中获得查看打开权限；')}}<br/>
              {{$lang('2、若不选择【应用范围】，则默认全部应用范围；')}} <br/>
              {{$lang('3、若不选择【时间范围】，则默认全部时间范围。')}}
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </mw-dialog>

    <mw-dialog title="选择主属部门" size="mini_small" :footerButton="deptBtns" ref="primaryDeptDialog" :close-on-click-modal="false">
        <mw-tree :url="primaryDUrl"
        :async="true" :expandedFirst="true"
        ref="primaryDept" :multiple="false"  :defaultParentId="user.id"></mw-tree>

    </mw-dialog>

    <!-- 为用户追加部门或者转换部门 -->
    <mw-dialog  size="mini_small" :footerButton="btns" ref="addDeptDialog" :close-on-click-modal="false">
      <!--<mw-tree :url="deptTreeUrl"
        :async="true" :expandedFirst="true"
          ref="deptTree" :multiple="false"></mw-tree>-->
      <mw-tree :url="deptTreeUrl" :async="true" :multiple="false" ref="deptTree" :defaultParams="defaultParams1"
               aliasId="departmentId" :autoLoad="false"   :expandedFirst="true" :selectFirst="true" ></mw-tree>
    </mw-dialog>
    <!-- 为导出部门用户-->
    <mw-dialog  size="mini_small" :footerButton="btns1" ref="addDeptDialog1" :close-on-click-modal="false">
      <mw-tree :url="deptTreeUrl" :threeState="true" :async="true" :multiple="true" ref="deptTree1" :defaultParams="defaultParams1"
               aliasId="departmentId" :autoLoad="false"   :expandedFirst="true" :selectFirst="true" ></mw-tree>
      <!--<mw-tree :url="deptTreeUrl" :threeState="true"
               :async="true" :expandedFirst="true"
               ref="deptTree1" :multiple="true"></mw-tree>-->
    </mw-dialog>

   <!-- 选择岗位 -->

    <mw-dialog ref="choosePost" :close-on-click-modal="false">
      <choosePost @confirm="confirmPost" @cancel="cancel('choosePost')"></choosePost>
    </mw-dialog>

    <infothird @confirm="confirmTwoRand" ref="secondRank"></infothird>



    <staff @confirm="employLevel"  ref="staffLevel"></staff>

    <infothird @confirm="cthirdLevel" ref="cthirdLevel"></infothird>

    <!-- 总管部门对话框 -->
    <zgdept ref="zgDeptDialog" @confirm="zgdeptChoose"></zgdept>

    <chooseSec @chooseSec="confirmSec" ref="chooseSec"></chooseSec>

    <!-- 一级单位 -->
    <first @confirm="firstDeptChoose" ref="firstDept"></first>

   <!-- 二级单位 -->
    <first @confirm="secondDeptChoose" ref="secondDept"></first>

    <!-- 三级单位 -->
    <first @confirm="thirdDeptChoose" ref="thirdDept"></first>


    <!--选择管理员-->
     <mw-dialog size="large_large"  title="选择用户" ref="userDialog" :footerButton="userFooterButton" :close-on-click-modal="false">
       <loadMan ref="chooseMangers" :RAdminData="deptManagers" :defaultParentId="defaultParentId"></loadMan>
     </mw-dialog>
  </div>
</template>

<script>
import organize from "./organize";

export default organize;
</script>

<style>
  .org_mgr .icon-grey{
    background-color:#9088881f;
  }
</style>
<style scoped>

.el-input {
  width: 70%;
}

.el-input__inner {
  height: 36px;
  border-bottom: 1px solid;
}

.el-dropdown-link {
  cursor: pointer;
  font-size: 13px;
}

.el-upload-list__item-name {
    color: #606266;
    display: block;
    margin-right: 40px;
    overflow: hidden;
    padding-left: 10px;
    text-overflow: ellipsis;
    -webkit-transition: color .3s;
    transition: color .3s;
    white-space: nowrap;
}
  .avatar {
    display:inline-block;
  }

  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .box{
		text-align: center;
		overflow: hidden;
		position: relative;
	}
	.box:before{
		content: "";
		width: 0;
		height: 100%;
		background: #000;
		padding: 14px 18px;
		position: absolute;
		top: 0;
		left: 50%;
		opacity: 0;
		transition: all 500ms cubic-bezier(0.47, 0, 0.745, 0.715) 0s;
	}
	.box:hover:before{
		width: 100%;
		left: 0;
		opacity: 0.5;
	}
  .box .box-content{
		width: 100%;
		padding: 14px 18px;
		color: #fff;
		position: absolute;
		top: 22%;
		left: 0;
	}

  .box .icon{
		padding: 0;
		margin: 0;
		list-style: none;
	}
	.box .icon li{
		display: inline-block;
	}
	.box .icon li a{
		display: block;
		width: 25px;
		height: 25px;
		line-height: 25px;
		border-radius: 50%;
		background: #f74e55;
		font-size: 17px;
		font-weight: 700;
		color: #fff;
		margin-right: 0px;
		opacity: 0;
		transform: translateY(50px);
		transition: all 0.5s ease 0s;
	}
	.box:hover .icon li a{
		opacity: 1;
		transform: translateY(0px);
		transition-delay: 0.5s;
	}

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/deptUser.vue